import React, { useState } from "react";
import PassportForm from "./PassportForm";
import VisaList from "./VisaList";
import NewVisaForm from "./NewVisaForm";

const VisaApplication = () => {
  const [activeTab, setActiveTab] = useState("passport");

  return (
    <div className="mx-auto">
      <h1 className="text-2xl font-bold mb-4">Visa Application @ VISAX</h1>
      <div className="flex gap-2">
        <button
          className={`p-2 flex-1 ${activeTab === "passport" ? "border-b-2 border-blue-500" : ""}`}
          onClick={() => setActiveTab("passport")}
        >
          🛂 My Passport
        </button>
        <button
          className={`p-2 flex-1 ${activeTab === "visas" ? "border-b-2 border-blue-500" : ""}`}
          onClick={() => setActiveTab("visas")}
        >
          💳 My Visas
        </button>
        <button
          className={`p-2 flex-1 ${activeTab === "newVisa" ? "border-b-2 border-blue-500" : ""}`}
          onClick={() => setActiveTab("newVisa")}
        >
          📄 New Application
        </button>
      </div>

      <div className="p-2">
        {activeTab === "passport" && <PassportForm />}
        {activeTab === "visas" && <VisaList />}
        {activeTab === "newVisa" && <NewVisaForm />}
      </div>
    </div>
  );
};

export default VisaApplication;
